import { render, staticRenderFns } from "./ConsumptionTable.component.vue?vue&type=template&id=ab8a1bfc&"
import script from "./ConsumptionTable.component.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionTable.component.vue?vue&type=script&lang=ts&"
import style0 from "./ConsumptionTable.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VIcon})
